import {
  ALLOW_WS_OVERRIDE,
  ASSISTANT_WS_QS_KEY,
  ASSISTANT_WS_SS_KEY,
  ASSISTANT_WS_URL,
} from '@skynet/config-provider';

import { createWsConnect } from '@skynet/data-ws-core';

import { prefix } from './actions';

/**
 * Resolves the Assistant WebSocket URL from query-string, sessionStorage, or
 * the default env value, then dispatches a `connect` action for the Assistant
 * channel.
 *
 * @example
 * store.dispatch(wsAssistantConnect());
 */
export const wsAssistantConnect = createWsConnect(prefix, {
  defaultUrl: ASSISTANT_WS_URL,
  ssKey: ASSISTANT_WS_SS_KEY,
  qsKey: ASSISTANT_WS_QS_KEY,
  allowOverride: ALLOW_WS_OVERRIDE,
});
